import React, { FC } from "react";
import { SubHeaderStyled } from "../PageHeaderStyled";
import InjectLegalAndTooltips from "~/components/InjectLegalAndTooltips";
import { useModal } from "~/hooks/useModal";
import { ModalKeys } from "~/constants/modal";
import { useGlobalOfferMerchData } from "~/hooks/useGlobalOfferMerchData";

interface Props {
  icon?: JSX.Element;
  text: string;
  discountModalLink?: string;
}

const Subheader: FC<Props> = ({ icon, text, discountModalLink }) => {
  const { openModalWithData } = useModal();
  const { data: offerMerchData } = useGlobalOfferMerchData();
  const reconsiderModal = offerMerchData?.productSelection?.reconsiderBanner?.modal;

  const handleModalClick = () => {
    openModalWithData(ModalKeys.DISCOUNT, {
      discountModal: {
        heading: reconsiderModal?.heading,
        disclaimers: reconsiderModal?.disclaimers,
        legals: reconsiderModal?.legals,
      },
    });
  };

  const modalLink =
    discountModalLink && reconsiderModal?.heading ? (
      <button className="subheader__modal-link" onClick={handleModalClick}>
        <InjectLegalAndTooltips copy={discountModalLink} />
      </button>
    ) : null;

  if (icon && text) {
    return (
      <SubHeaderStyled>
        <span className="subheader__icon">{icon}</span>
        <p className="subheader__text" data-testid="subheader__text">
          <InjectLegalAndTooltips copy={text} /> {modalLink}
        </p>
      </SubHeaderStyled>
    );
  }

  if (text)
    return (
      <SubHeaderStyled>
        <p className="subheader__text" data-testid="subheader__text">
          <InjectLegalAndTooltips copy={text} /> {modalLink}
        </p>
      </SubHeaderStyled>
    );

  return null;
};

Subheader.displayName = "Subheader";

export default Subheader;
